var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIconOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_142_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.85714 4.77778C8.14286 2.55556 9.15857 2 12 2C14.8414 2 17.1429 3.98889 17.1429 6.44444V9.77778M12 15.3333C12.341 15.3333 12.668 15.2163 12.9091 15.0079C13.1503 14.7995 13.2857 14.5169 13.2857 14.2222C13.2857 13.9275 13.1503 13.6449 12.9091 13.4365C12.668 13.2282 12.341 13.1111 12 13.1111C11.659 13.1111 11.332 13.2282 11.0909 13.4365C10.8497 13.6449 10.7143 13.9275 10.7143 14.2222C10.7143 14.5169 10.8497 14.7995 11.0909 15.0079C11.332 15.2163 11.659 15.3333 12 15.3333ZM12 15.3333V18.6667M5.05714 9.77778H18.9429C20.0743 9.77778 21 10.5778 21 11.5556V19.3333C21 20.8 19.6114 22 17.9143 22H6.08571C4.38857 22 3 20.8 3 19.3333V11.5556C3 10.5778 3.92571 9.77778 5.05714 9.77778Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_142_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIconOpen);
export default __webpack_public_path__ + "static/media/lock-icon-open.f9210ef267694e8a7ac1d5d30561bca8.svg";
export { ForwardRef as ReactComponent };